const translations = {
    en: {
        nav: {
            home: 'Home',
            about: 'About',
            services: 'Services',
            portfolio: 'Portfolio',
            blog: 'Blog',
            contact: 'Contact',
            explore: 'Explore MassDev',
            projects: 'Projects',
            languageSwitch: 'العربية'
        },
        hero: {
            title: 'MassDev: Powering Your Digital Success with Innovative Web Solutions!',
            contactButton: 'Contact Us'
        },
        error404: {
            title: '404!',
            subtitle: 'Page not found',
            description: 'The page you were looking for could not be found.',
            button: 'Back To Homepage'
        },
        homepage: {
            slider: {
                subtitle: 'Specialist in Modern Web Solutions',
                title: 'FinTech Development.',
                services: [
                    {
                        title: 'FinTech Solutions',
                        description: 'Secure payment systems, digital banking platforms, and compliance-ready financial applications built for scale.'
                    },
                    {
                        title: 'Web Development',
                        description: 'High-performance web applications with modern frameworks, cloud architecture, and responsive design.'
                    },
                    {
                        title: 'UI/UX Design',
                        description: 'User-centered interfaces optimized for conversion, accessibility, and Arabic market expertise.'
                    }
                ]
            },
            about: {
                title: 'Why MassDev',
                subtitle: 'About MassDev',
                description: 'MassDev is a specialist software development company focused on building modern, scalable web platforms, with a strong core expertise in FinTech systems. With over 35 years of combined professional experience, we deliver high-performance digital products powered by advanced AI-driven architecture, security-first engineering, and world-class UI/UX design.',
                fintechTitle: 'FinTech Specialization',
                fintechDesc: 'Deep expertise in digital banking, payment gateways, investment platforms, and compliance-ready financial systems built for scale and security.',
                aiTitle: 'AI-Driven Development',
                aiDesc: 'Leveraging artificial intelligence throughout the development lifecycle for faster delivery, higher reliability, and future-proof systems.',
                counters: {
                    experience: 'Years of Experience',
                    projects: 'Projects Delivered',
                    aiProjects: 'AI Projects'
                }
            },
            services: {
                subtitle: 'What We Do',
                title: 'Core Expertise',
                description: 'Delivering technically robust, intuitive, and conversion-focused solutions.',
                button: 'More  Services',
                items: [
                    {
                        title: 'FinTech Platforms',
                        description: 'Digital banking, payment gateways, and compliance-ready financial solutions.'
                    },
                    {
                        title: 'Modern Web Development',
                        description: 'High-performance web applications and scalable cloud architectures.'
                    },
                    {
                        title: 'UI/UX Excellence',
                        description: 'Trust-driven interfaces with Arabic market expertise.'
                    },
                    {
                        title: 'AI-Driven Solutions',
                        description: 'Intelligent automation and AI-assisted architecture.'
                    }
                ]
            },
            capabilities: {
                subtitle: 'Our Capabilities',
                title: 'Comprehensive Solutions',
                description: 'MassDev delivers comprehensive solutions across multiple domains with deep technical expertise and industry-leading practices.'
            },
            features: [
                {
                    title: "FinTech Platforms",
                    items: [
                        "Digital banking systems",
                        "Payment gateways & wallets",
                        "Investment & trading platforms",
                        "KYC, AML & compliance-ready systems"
                    ]
                },
                {
                    title: "Modern Web Development",
                    items: [
                        "High-performance web applications",
                        "SaaS platforms",
                        "Enterprise dashboards",
                        "API-first and microservices systems"
                    ]
                },
                {
                    title: "AI-Driven Development",
                    items: [
                        "AI-assisted system architecture",
                        "Intelligent data processing & automation",
                        "Predictive analytics & financial insights",
                        "Smart UX personalization"
                    ]
                },
                {
                    title: "UI/UX Excellence",
                    items: [
                        "User-centric UX research",
                        "Conversion-focused design systems",
                        "Arabic & international market expertise",
                        "Enterprise-grade design consistency"
                    ]
                }
            ],
            works: {
                subtitle: 'Quality is our beauty',
                title: 'Our Works',
                description: 'MassDev delivers comprehensive solutions across multiple domains with deep technical expertise and industry-leading practices.',
                viewAllButton: 'All Projects'
            },
            latestProjects: {
                subtitle: 'Latest News',
                title: 'Our Latest Projects',
                description: 'MassDev follows a rigorous engineering mindset focused on security, performance, and long-term maintainability.',
                learnMore: 'Learn More',
                viewProject: 'View Project'
            },
            callAction: {
                readyText: 'READY TO BUILD SOMETHING GREAT?',
                heading: "Let's Build Your Vision",
                button: 'Start Your Project'
            },
            funFacts: {
                title: 'Fun Facts About Us',
                experience: 'Years of Combined Professional Experience',
                projects: 'Projects Delivered with Excellence',
                satisfaction: 'Client Satisfaction Rate'
            },
            testimonials: {
                title: 'What Clients Say',
                items: [
                    {
                        text: 'Working with MassDev was a game-changer for our financial platform. Their expertise in FinTech and attention to security details gave us confidence from day one.',
                        author: 'Aklima',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'The team delivered a robust, scalable solution that exceeded our expectations. Their AI-driven approach significantly reduced our development time.',
                        author: 'Fatima Asrafy',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'MassDev\'s understanding of the Arabic market and RTL design was exceptional. They built a platform that truly resonates with our users.',
                        author: 'Jannat Tumpa',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'Professional, reliable, and technically excellent. MassDev transformed our vision into a high-performance digital product.',
                        author: 'Johns Due',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'Their compliance-ready approach and security-first engineering made our financial application launch smooth and worry-free.',
                        author: 'John Doe',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'MassDev\'s expertise in modern web frameworks and cloud architecture helped us build a platform that scales effortlessly.',
                        author: 'Amar Orthi',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'The UI/UX design was outstanding - intuitive, accessible, and optimized for conversion. Our user engagement increased significantly.',
                        author: 'Fatima Ma',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'From concept to deployment, MassDev demonstrated deep technical knowledge and commitment to excellence. Highly recommended.',
                        author: 'JON CUMMINS',
                        position: 'COO, AMERIMAR ENTERPRISES, INC.'
                    }
                ]
            },
            brands: {
                title: 'Our Clients'
            }
        },
        demo: {
            banner: {
                title: 'Welcome to massDev Creative Agency 2026',
                exploreButton: 'Explore MassDev',
                arabicButton: 'MassDev Arabic'
            },
            projects: {
                welcome: 'Welcome To mass.Dev',
                subtitle: 'Our Projects',
                tabs: {
                    all: 'All Projects',
                    fintech: 'Fintech',
                    social: 'Social',
                    commercial: 'Commercial',
                    ai: 'AI'
                }
            },
            tools: {
                title: 'Our Tools',
                description: 'MassDev is designed for everyone. It doesn\'t matter if you\'re a React Guru or just a complete beginner.',
                features: [
                    {
                        title: 'Modern JS UI frameworks',
                        description: 'We specialize in React, Vue, and Next.js, delivering exceptional web applications and user experiences.'
                    },
                    {
                        title: 'Perfect Responsive',
                        description: 'We specialize in responsive web design, crafting visually stunning websites for all devices.'
                    },
                    {
                        title: 'No SQL',
                        description: 'We specialize in developing with NoSQL databases, powering scalable and efficient data solutions.'
                    },
                    {
                        title: 'RTL CSS',
                        description: 'We specialize in developing the best RTL CSS for seamless right-to-left language support.'
                    },
                    {
                        title: 'Arabic UX',
                        description: 'We are Arabic UXers, creating exceptional user experiences tailored for the Arab world.'
                    },
                    {
                        title: 'Modern Design',
                        description: 'We specialize in developing modern designs that are visually captivating and innovative.'
                    },
                    {
                        title: '24 Support System',
                        description: 'We provide 24 hours support for all clients.'
                    },
                    {
                        title: 'CMS Shopify',
                        description: 'We specialize in creating Shopify stores, delivering seamless e-commerce experiences for businesses.'
                    }
                ]
            },
            performance: {
                title: 'mass.Dev Performance',
                description: 'We pride ourselves on creating websites that deliver top-notch performance, ensuring the best user experience on the web.',
                gtmetrixTitle: 'Gtmetrix Scores',
                metrics: {
                    pageSpeed: 'PageSpeed',
                    yslow: 'YSlow',
                    fullyLoaded: 'Fully Loaded'
                }
            },
            responsive: {
                title: 'mass.Dev UX works perfectly on any device.',
                description: 'At our web design agency, we excel in crafting websites with the utmost care for Arab users, prioritizing culturally relevant experiences, intuitive interfaces, seamless navigation, and personalized content, ensuring the highest level of user satisfaction and engagement in the Arab digital landscape.',
                devices: {
                    phone: 'Phone',
                    tablet: 'Tablet',
                    desktop: 'Desktop'
                },
                subtitle: '- Separate Options for Each Screen Size'
            },
            faq: {
                title: 'Have a',
                titleHighlight: 'Question?',
                description: 'Check out our FAQ section to see if we can help.',
                questions: [
                    {
                        question: '1. What makes your web development company specialized in UX, React, and building Arabic big platforms?',
                        answer: 'We have a dedicated team of UX experts who understand the unique needs of Arabic users and can create engaging and culturally relevant experiences. We also have extensive experience in React development, enabling us to build robust and scalable platforms.'
                    },
                    {
                        question: '2. How do you ensure a user-centric approach in your UX design process?',
                        answer: 'We conduct thorough user research, create user personas, and perform usability testing to understand user behaviors and preferences. This helps us design intuitive interfaces and seamless user journeys that prioritize user satisfaction.'
                    },
                    {
                        question: '3. Can you provide examples of the big platforms you have built for Arabic clients?',
                        answer: 'We have successfully built large-scale platforms for various industries, such as e-commerce, healthcare, and finance. Some notable examples include online Projects, healthcare management systems, and ERPs platforms, all tailored for the Arabic market.'
                    },
                    {
                        question: '4. What advantages does React offer for building Arabic big platforms?',
                        answer: 'React is a powerful JavaScript library that allows for the development of highly interactive and dynamic user interfaces. Its component-based architecture enables efficient development, code reusability, and seamless integration with backend systems, making it ideal for building complex Arabic platforms.'
                    },
                    {
                        question: '5. How do you ensure Arabic language support and cultural relevance in your platform development?',
                        answer: 'We have native Arabic speakers in our team who understand the nuances of the language and cultural aspects. We ensure proper Arabic localization, right-to-left (RTL) support, and design elements that resonate with Arab users to provide an authentic and user-friendly experience.'
                    },
                    {
                        question: '6. Do you provide ongoing support and maintenance for the platforms you develop?',
                        answer: 'Yes, we offer comprehensive support and maintenance services to ensure your platform stays up-to-date, secure, and optimized. We provide regular updates, bug fixes, performance enhancements, and technical assistance to meet your evolving needs.'
                    },
                    {
                        question: '7. How can we get started with your web development services for our Arabic big platform?',
                        answer: 'Simply reach out to us through our website or contact information. We\'ll schedule a consultation to discuss your requirements, project scope, timelines, and provide you with a tailored solution that aligns with your goals and objectives.'
                    }
                ],
                cta: {
                    title: 'Let\'s Start Your Project',
                    subtitle: 'Don\'t Hesitate',
                    buttonText: 'Let\'s Go'
                }
            },
            support: {
                title: 'Dedicated Support',
                description: 'Need support ? Submit a ticket. We will be happy to assist you.',
                contactButton: 'Contact Us',
                supportTime: 'Support Time:',
                supportDays: 'Sunday – Thursday',
                responseTime: 'Response Time:',
                responseHours: 'Maximum 24 hours'
            },
            footer: {
                agency: 'mass.Dev Agency.',
                title: 'Let\'s Work',
                contactButton: 'Contact Us'
            }
        },
        services: {
            subtitle: 'What We Offer',
            title: 'Our Services',
            description: 'Comprehensive solutions tailored to your business needs, from strategy to execution.',
            items: [
                {
                    title: 'Business Strategy',
                    description: 'Tailored business strategies for growth and success. Data-driven insights, expert consultants, and informed decision-making for sustainable results.'
                },
                {
                    title: 'Website Development',
                    description: 'Custom web development solutions for your online presence. Expert coding, responsive design, and seamless user experiences to boost your digital success.'
                },
                {
                    title: 'Marketing & Reporting',
                    description: 'Comprehensive marketing and reporting solutions to enhance your business visibility. Data-driven insights and analytics for informed decision-making and measurable results.'
                },
                {
                    title: 'Mobile App Development',
                    description: 'Innovative mobile app development tailored to your business needs. Engaging user interfaces, seamless functionality, and optimal performance for maximum impact.'
                },
                {
                    title: 'Financial Website Design',
                    description: 'Modern financial website design services that showcase your professionalism. Clean interfaces, intuitive navigation, and secure features to build trust with clients.'
                },
                {
                    title: 'Arabic UX Design',
                    description: 'Expert Arabic UX design services for an exceptional user experience. Intuitive interfaces, culturally sensitive designs, and seamless interactions tailored to Arabic-speaking users.'
                }
            ]
        },
        portfolio: {
            subtitle: 'Our Impact',
            title: 'Our Freemiums',
            description: 'MassDev empowers the community with UX expertise, offering free and premium events to enhance digital experiences for all.',
            readMore: 'Read More',
            viewProject: 'View Project',
            items: [
                {
                    id: 'jerusalem-ux-week',
                    category: 'User Experience',
                    title: 'Jerusalem UX Week'
                },
                {
                    id: 'hebron-ux-freemium',
                    category: 'User Experience',
                    title: 'Hebron UX Freemium'
                },
                {
                    id: 'web-dev-2023',
                    category: 'Development',
                    title: 'Web Dev in 2023'
                },
                {
                    id: 'empowering-fintech',
                    category: 'Business Strategy',
                    title: 'Empowering Fintech'
                },
                {
                    id: 'ai-dev-tickets',
                    category: 'AI Dev',
                    title: 'Getting tickets to the big show'
                },
                {
                    id: 'dev-tickets',
                    category: 'Development',
                    title: 'Getting tickets to the big show'
                }
            ]
        },
        freemiums: {
            pageTitle: 'Freemiums',
            ourImpact: 'Our Impact',
            massDev: 'MassDev Freemiums',
            ourFreemiums: 'Our Freemiums',
            description: 'MassDev empowers the community with UX expertise, offering free and premium events to enhance digital experiences for all.',
            caseStudy: 'Case Study'
        },
        team: {
            title: 'Skilled Team',
            description: 'Introducing our skilled team, experts in their fields, ready to drive your success with unmatched proficiency.'
        },
        testimonial: {
            subtitle: 'Client Testimonials',
            title: 'What Our Clients Say',
            description: 'Hear from our satisfied clients about their experience working with MassDev.'
        },
        slogan: {
            subtitle: 'Our Vision',
            title: 'Building Tomorrow, Today',
            description: 'Where innovation meets execution, and ideas transform into digital excellence.',
            mainSlogan: 'Code with Purpose. Build with Passion. Scale with Precision.',
            subSlogan: 'We don\'t just write code—we architect digital ecosystems that empower businesses, delight users, and stand the test of time. From FinTech platforms to AI-driven solutions, every line we write is a step toward your success.',
            ctaButton: 'Start Your Journey'
        },
        brand: {
            subtitle: 'Our Partners',
            title: 'Trusted By Industry Leaders',
            description: 'We are proud to work with leading brands and organizations worldwide.'
        },
        blog: {
            subtitle: 'Our Blog',
            title: 'Latest News',
            description: 'Stay updated with the latest insights, trends, and innovations in web development and FinTech.',
            readMore: 'Read More'
        },
        footer: {
            readyText: 'Ready To Do This',
            heading: "Let's get to work",
            contactButton: 'Contact Us',
            quickLink: {
                title: 'Quick Link',
                team: 'Our Team',
                explore:'Explore MassDev',
                projects: 'Projects',
                home: 'Home',
                letsTalk: "Let's Talk"
            },
            sayHello: {
                title: 'Say Hello'
            },
            copyright: 'Copyright © 2026 MassDev. All Rights Reserved.'
        },
        contact: {
            pageTitle: 'Contact',
            breadcrumb: {
                title: 'Contact With Us',
                description: 'We look forward to hearing from you! Contact us today to discuss your web development needs and create exceptional digital experiences together.'
            },
            info: {
                phone: {
                    title: 'Contact With Phone Number'
                },
                email: {
                    title: 'Email Address'
                },
                location: {
                    title: 'Location',
                    address: 'Al-Qala\'a #3 St. Jerusalem'
                }
            },
            form: {
                title: 'Contact Us.',
                description: 'We eagerly await your message! Get in touch with us today to discuss your project requirements and let\'s bring your vision to life.',
                fields: {
                    name: 'Your Name',
                    email: 'Your Email',
                    phone: 'Phone Number',
                    subject: 'Subject',
                    message: 'Your Message'
                },
                submit: 'Submit Now',
                success: 'Your Message has been successfully sent. I will contact you soon.'
            }
        },
        servicePage: {
            pageTitle: 'Services',
            breadcrumb: {
                title: 'Service',
                home: 'Home'
            },
            development: {
                title: 'Development',
                description: 'MassDev is designed for everyone. It doesn\'t matter if you\'re a React Guru or just a complete beginner.',
                features: [
                    {
                        title: 'Modern JS UI frameworks',
                        description: 'We specialize in React, Vue, and Next.js, delivering exceptional web applications and user experiences.'
                    },
                    {
                        title: 'Perfect Responsive',
                        description: 'We specialize in responsive web design, crafting visually stunning websites for all devices.'
                    },
                    {
                        title: 'No SQL',
                        description: 'We specialize in developing with NoSQL databases, powering scalable and efficient data solutions.'
                    },
                    {
                        title: 'RTL CSS',
                        description: 'We specialize in developing the best RTL CSS for seamless right-to-left language support.'
                    },
                    {
                        title: 'Arabic UX',
                        description: 'We are Arabic UXers, creating exceptional user experiences tailored for the Arab world.'
                    },
                    {
                        title: 'Modern Design',
                        description: 'We specialize in developing modern designs that are visually captivating and innovative.'
                    },
                    {
                        title: '24 Support System',
                        description: 'We provide 24 hours support for all clients.'
                    },
                    {
                        title: 'CMS Shopify',
                        description: 'We specialize in creating Shopify stores, delivering seamless e-commerce experiences for businesses.'
                    }
                ]
            }
        },
        aboutPage: {
            pageTitle: 'About',
            breadcrumb: {
                title: 'About',
                home: 'Home'
            },
            mainSection: {
                title: 'About',
                description: 'Are you seeking cutting-edge web development solutions coupled with exceptional user experience? Look no further than Mass Dev, a leading modern web development and UX agency based in Jerusalem. Our team of talented and creative experts is here to bring your digital vision to life.',
                whoWeAre: {
                    title: 'Who we are',
                    description1: 'We pride ourselves on delivering top-notch web development services that go beyond mere aesthetics. We understand the significance of user experience and its impact on the success of your online presence. That\'s why our dedicated team combines technical prowess with artistic flair to create seamless and engaging digital experiences.',
                    description2: 'Tailored Solutions for Every Business: Whether you\'re a startup, small business, or enterprise, we offer scalable solutions that align with your specific goals and budget. Our flexible approach ensures that you receive a customized web development and UX strategy that caters to your business needs.'
                }
            },
            culturalInsights: {
                title: 'Jerusalem-Based Cultural Insights'
            },
            findWork: {
                title: 'Find Your Work Now',
                description: 'Jerusalem-Based Cultural Insights: Situated in the vibrant city of Jerusalem, Mass Dev draws inspiration from the rich history, diversity, and creativity that surrounds us. We infuse these cultural insights into our work, crafting unique digital experiences that resonate with your target market',
                button: 'Get Started'
            },
            team: {
                title: 'Skilled Team',
                description: 'Expertise in Modern Web Development: Our team of seasoned developers stays up-to-date with the latest industry trends and technologies. From responsive web design to interactive web applications, we have the skills to build robust solutions tailored to your unique requirements.'
            }
        },
        portfolioPage: {
            pageTitle: 'Portfolio',
            breadcrumb: {
                title: 'Portfolio',
                home: 'Home'
            },
            featured: {
                title: 'Featured',
                description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.'
            },
            allWorks: {
                title: 'All Works',
                description: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.',
                viewMore: 'View More Project'
            },
            portfolioItems: [
                {
                    category: 'Development',
                    title: 'Getting tickets to the big show',
                    caseStudy: 'Case Study',
                    viewDetails: 'View Details'
                },
                {
                    category: 'Development',
                    title: 'Getting tickets to the big show',
                    caseStudy: 'Case Study',
                    viewDetails: 'View Details'
                },
                {
                    category: 'Development',
                    title: 'Getting tickets to the big show',
                    caseStudy: 'Case Study',
                    viewDetails: 'View Details'
                },
                {
                    category: 'Development',
                    title: 'Getting tickets to the big show',
                    caseStudy: 'Case Study',
                    viewDetails: 'View Details'
                },
                {
                    category: 'Development',
                    title: 'Getting tickets to the big show',
                    caseStudy: 'Case Study',
                    viewDetails: 'View Details'
                },
                {
                    category: 'Development',
                    title: 'Getting tickets to the big show',
                    caseStudy: 'Case Study',
                    viewDetails: 'View Details'
                }
            ]
        }
    },
    ar: {
        nav: {
            home: 'الرئيسية',
            about: 'من نحن',
            services: 'خدماتنا',
            portfolio: 'أعمالنا',
            blog: 'المدونة',
            contact: 'تواصل معنا',
            explore: 'استكشف MassDev',
            projects: 'المشاريع',
            languageSwitch: 'English'
        },
        hero: {
            title: 'Mass.Dev: نمكّن نجاحك الرقمي بحلول ويب مبتكرة!',
            contactButton: 'تواصل معنا'
        },
        error404: {
            title: '404!',
            subtitle: 'الصفحة غير موجودة',
            description: 'الصفحة التي تبحث عنها غير موجودة.',
            button: 'العودة للصفحة الرئيسية'
        },
        homepage: {
            slider: {
                subtitle: 'متخصصون في حلول الويب الحديثة',
                title: 'تطوير التقنية المالية.',
                services: [
                    {
                        title: 'حلول التقنية المالية',
                        description: 'أنظمة دفع آمنة، منصات مصرفية رقمية، وتطبيقات مالية جاهزة للامتثال مبنية للتوسع.'
                    },
                    {
                        title: 'تطوير الويب',
                        description: 'تطبيقات ويب عالية الأداء مع أطر عمل حديثة، بنية سحابية، وتصميم متجاوب.'
                    },
                    {
                        title: 'تصميم UI/UX',
                        description: 'واجهات محورها المستخدم محسّنة للتحويل، وسهولة الوصول، وخبرة في السوق العربي.'
                    }
                ]
            },
            about: {
                title: 'لماذا MassDev',
                subtitle: 'عن MassDev',
                description: 'MassDev متخصصة في تطوير الويب الحديث ومنصات التقنية المالية، لتقديم حلول رقمية موثوقة، مستقرة، وقابلة للنمو. بخبرة مهنية تراكمية تتجاوز 35 عامًا، تجمع MassDev بين الخبرة العميقة، والهندسة الدقيقة، والذكاء الاصطناعي، لبناء أنظمة مالية ورقمية تُشعر المستخدم بالأمان منذ اللحظة الأولى.',
                fintechTitle: 'التخصص في التقنية المالية',
                fintechDesc: 'نطوّر منصات مالية تُصمَّم بعقلية الامتثال والاعتمادية: أنظمة مصرفية رقمية موثوقة، بوابات دفع ومحافظ إلكترونية آمنة، منصات استثمار وتداول عالية الاستقرار، وتطبيق معايير KYC و AML من اليوم الأول.',
                aiTitle: 'تطوير مدعوم بالذكاء الاصطناعي',
                aiDesc: 'نستخدم الذكاء الاصطناعي لتعزيز دقة البيانات والتحليلات، أتمتة العمليات المالية، التنبؤ بالمخاطر والسلوكيات، تحسين الأداء وتجربة المستخدم، وبناء أنظمة قادرة على التعلّم والتطور.',
                counters: {
                    experience: 'سنوات من الخبرة',
                    projects: 'مشاريع منجزة',
                    aiProjects: 'مشاريع AI'
                }
            },
            services: {
                subtitle: 'ما نقدمه',
                title: 'الخبرة الأساسية',
                description: 'تقديم حلول قوية تقنيًا وبديهية ومركزة على التحويل.',
                button: 'خدمات أخرى',
                items: [
                    {
                        title: 'منصات التقنية المالية',
                        description: 'الخدمات المصرفية الرقمية، وبوابات الدفع، والحلول المالية الجاهزة للامتثال.'
                    },
                    {
                        title: 'تطوير الويب الحديث',
                        description: 'تطبيقات ويب عالية الأداء وبنى سحابية قابلة للتوسع.'
                    },
                    {
                        title: 'التميز في UI/UX',
                        description: 'واجهات موثوقة مع خبرة في السوق العربي.'
                    },
                    {
                        title: 'حلول مدفوعة بالذكاء الاصطناعي',
                        description: 'أتمتة ذكية وهندسة معمارية بمساعدة الذكاء الاصطناعي.'
                    }
                ]
            },
            capabilities: {
                subtitle: 'قدراتنا',
                title: 'حلول شاملة',
                description: 'تقدم MassDev حلولاً شاملة عبر مجالات متعددة مع خبرة تقنية عميقة وممارسات رائدة في الصناعة.'
            },
            features: [
                {
                    title: "منصات التقنية المالية",
                    items: [
                        "أنظمة مصرفية رقمية",
                        "بوابات دفع ومحافظ إلكترونية",
                        "منصات استثمار وتداول",
                        "أنظمة جاهزة للامتثال KYC و AML"
                    ]
                },
                {
                    title: "تطوير الويب الحديث",
                    items: [
                        "تطبيقات ويب عالية الأداء",
                        "منصات SaaS",
                        "لوحات تحكم المؤسسات",
                        "أنظمة API والخدمات الصغيرة"
                    ]
                },
                {
                    title: "التطوير المدعوم بالذكاء الاصطناعي",
                    items: [
                        "هندسة معمارية بمساعدة الذكاء الاصطناعي",
                        "معالجة بيانات ذكية وأتمتة",
                        "تحليلات تنبؤية ورؤى مالية",
                        "تخصيص ذكي لتجربة المستخدم"
                    ]
                },
                {
                    title: "التميز في UI/UX",
                    items: [
                        "بحث تجربة المستخدم المتمحور حول المستخدم",
                        "أنظمة تصميم مركزة على التحويل",
                        "خبرة في السوق العربي والدولي",
                        "اتساق تصميم على مستوى المؤسسات"
                    ]
                }
            ],
            works: {
                subtitle: 'الجودة هي جمالنا',
                title: 'أعمالنا',
                description: 'تقدم MassDev حلولاً شاملة عبر مجالات متعددة مع خبرة تقنية عميقة وممارسات رائدة في الصناعة.',
                viewAllButton: 'جميع المشاريع'
            },
            latestProjects: {
                subtitle: 'آخر الأخبار',
                title: 'أحدث مشاريعنا',
                description: 'تتبع MassDev عقلية هندسية دقيقة تركز على الأمان والأداء وقابلية الصيانة طويلة الأجل.',
                learnMore: 'اعرف المزيد',
                viewProject: 'عرض المشروع'
            },
            callAction: {
                readyText: 'مستعد لبناء شيء عظيم؟',
                heading: 'لنبني رؤيتك',
                button: 'ابدأ مشروعك'
            },
            funFacts: {
                title: 'حقائق ممتعة عنا',
                experience: 'سنوات من الخبرة المهنية المشتركة',
                projects: 'مشاريع منجزة بتميز',
                satisfaction: 'معدل رضا العملاء'
            },
            testimonials: {
                title: 'ماذا يقول العملاء',
                items: [
                    {
                        text: 'العمل مع MassDev كان نقطة تحول لمنصتنا المالية. خبرتهم في التقنية المالية واهتمامهم بتفاصيل الأمان منحنا الثقة من اليوم الأول.',
                        author: 'أكليما',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'قدم الفريق حلاً قوياً وقابلاً للتوسع فاق توقعاتنا. نهجهم المدعوم بالذكاء الاصطناعي قلل بشكل كبير من وقت التطوير.',
                        author: 'فاطمة أشرفي',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'فهم MassDev للسوق العربي وتصميم RTL كان استثنائياً. بنوا منصة تتفاعل حقاً مع مستخدمينا.',
                        author: 'جنات تومبا',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'محترفون، موثوقون، ومتميزون تقنياً. حوّل MassDev رؤيتنا إلى منتج رقمي عالي الأداء.',
                        author: 'جونز دو',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'نهجهم الجاهز للامتثال والهندسة التي تضع الأمان أولاً جعل إطلاق تطبيقنا المالي سلساً وخالياً من القلق.',
                        author: 'جون دو',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'خبرة MassDev في أطر الويب الحديثة والبنية السحابية ساعدتنا في بناء منصة تتوسع بسهولة.',
                        author: 'عمر أورثي',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'تصميم UI/UX كان رائعاً - بديهي، سهل الوصول، ومحسّن للتحويل. زاد تفاعل المستخدمين بشكل كبير.',
                        author: 'فاطمة ما',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    },
                    {
                        text: 'من المفهوم إلى النشر، أظهر MassDev معرفة تقنية عميقة والتزاماً بالتميز. موصى به بشدة.',
                        author: 'جون كامينز',
                        position: 'المدير التنفيذي للعمليات، AMERIMAR ENTERPRISES, INC.'
                    }
                ]
            },
            brands: {
                title: 'عملاؤنا'
            }
        },
        demo: {
            banner: {
                title: 'مرحباً بك في Mass.Dev الوكالة الإبداعية 2026',
                exploreButton: 'استكشف Mass.Dev',
                arabicButton: 'Mass.Dev بالعربية'
            },
            projects: {
                welcome: 'مرحباً بك في Mass.Dev',
                subtitle: 'مشاريعنا',
                tabs: {
                    all: 'جميع المشاريع',
                    fintech: 'التكنولوجيا المالية',
                    social: 'التواصل الاجتماعي',
                    commercial: 'التجارية',
                    ai: 'الذكاء الاصطناعي'
                }
            },
            tools: {
                title: 'أدواتنا',
                description: 'Mass.Dev مصمم للجميع. لا يهم إذا كنت خبيراً في React أو مبتدئاً تماماً.',
                features: [
                    {
                        title: 'أطر عمل واجهة المستخدم الحديثة',
                        description: 'نحن متخصصون في React و Vue و Next.js، نقدم تطبيقات ويب استثنائية وتجارب مستخدم رائعة.'
                    },
                    {
                        title: 'تصميم متجاوب مثالي',
                        description: 'نحن متخصصون في تصميم الويب المتجاوب، نصنع مواقع ويب مذهلة بصرياً لجميع الأجهزة.'
                    },
                    {
                        title: 'قواعد بيانات NoSQL',
                        description: 'نحن متخصصون في التطوير باستخدام قواعد بيانات NoSQL، نوفر حلول بيانات قابلة للتوسع وفعالة.'
                    },
                    {
                        title: 'CSS من اليمين لليسار',
                        description: 'نحن متخصصون في تطوير أفضل CSS من اليمين لليسار لدعم اللغات السلس.'
                    },
                    {
                        title: 'تجربة مستخدم عربية',
                        description: 'نحن خبراء تجربة المستخدم العربية، نصنع تجارب مستخدم استثنائية مصممة خصيصاً للعالم العربي.'
                    },
                    {
                        title: 'تصميم حديث',
                        description: 'نحن متخصصون في تطوير تصاميم حديثة جذابة بصرياً ومبتكرة.'
                    },
                    {
                        title: 'نظام دعم على مدار الساعة',
                        description: 'نحن نقدم دعماً على مدار 24 ساعة لجميع العملاء.'
                    },
                    {
                        title: 'نظام إدارة المحتوى Shopify',
                        description: 'نحن متخصصون في إنشاء متاجر Shopify، نقدم تجارب تجارة إلكترونية سلسة للشركات.'
                    }
                ]
            },
            performance: {
                title: 'أداء Mass.Dev',
                description: 'نفخر بإنشاء مواقع ويب تقدم أداءً من الدرجة الأولى، مما يضمن أفضل تجربة مستخدم على الويب.',
                gtmetrixTitle: 'نتائج Gtmetrix',
                metrics: {
                    pageSpeed: 'سرعة الصفحة',
                    yslow: 'YSlow',
                    fullyLoaded: 'التحميل الكامل'
                }
            },
            responsive: {
                title: 'تجربة المستخدم في Mass.Dev تعمل بشكل مثالي على أي جهاز.',
                description: 'في وكالة تصميم الويب الخاصة بنا، نتفوق في صياغة مواقع الويب بأقصى قدر من العناية للمستخدمين العرب، مع إعطاء الأولوية للتجارب ذات الصلة الثقافية، والواجهات البديهية، والتنقل السلس، والمحتوى المخصص، مما يضمن أعلى مستوى من رضا المستخدم والمشاركة في المشهد الرقمي العربي.',
                devices: {
                    phone: 'الهاتف',
                    tablet: 'الجهاز اللوحي',
                    desktop: 'سطح المكتب'
                },
                subtitle: '- خيارات منفصلة لكل حجم شاشة'
            },
            faq: {
                title: 'هل لديك',
                titleHighlight: 'سؤال؟',
                description: 'تحقق من قسم الأسئلة الشائعة لمعرفة ما إذا كان بإمكاننا المساعدة.',
                questions: [
                    {
                        question: '1. ما الذي يجعل شركة تطوير الويب الخاصة بكم متخصصة في تجربة المستخدم و React وبناء المنصات العربية الكبيرة؟',
                        answer: 'لدينا فريق متخصص من خبراء تجربة المستخدم الذين يفهمون الاحتياجات الفريدة للمستخدمين العرب ويمكنهم إنشاء تجارب جذابة وذات صلة ثقافية. لدينا أيضاً خبرة واسعة في تطوير React، مما يمكننا من بناء منصات قوية وقابلة للتوسع.'
                    },
                    {
                        question: '2. كيف تضمنون نهجاً يركز على المستخدم في عملية تصميم تجربة المستخدم؟',
                        answer: 'نجري بحثاً شاملاً للمستخدمين، ونقوم بإنشاء شخصيات المستخدمين، ونجري اختبارات قابلية الاستخدام لفهم سلوكيات المستخدمين وتفضيلاتهم. يساعدنا هذا في تصميم واجهات بديهية ورحلات مستخدم سلسة تعطي الأولوية لرضا المستخدم.'
                    },
                    {
                        question: '3. هل يمكنكم تقديم أمثلة على المنصات الكبيرة التي قمتم ببنائها للعملاء العرب؟',
                        answer: 'لقد نجحنا في بناء منصات واسعة النطاق لمختلف الصناعات، مثل التجارة الإلكترونية والرعاية الصحية والتمويل. تتضمن بعض الأمثلة البارزة المشاريع عبر الإنترنت وأنظمة إدارة الرعاية الصحية ومنصات تخطيط موارد المؤسسات، وكلها مصممة خصيصاً للسوق العربي.'
                    },
                    {
                        question: '4. ما هي المزايا التي يقدمها React لبناء المنصات العربية الكبيرة؟',
                        answer: 'React هي مكتبة JavaScript قوية تسمح بتطوير واجهات مستخدم تفاعلية وديناميكية للغاية. تتيح بنيتها القائمة على المكونات التطوير الفعال وإعادة استخدام الكود والتكامل السلس مع أنظمة الخلفية، مما يجعلها مثالية لبناء المنصات العربية المعقدة.'
                    },
                    {
                        question: '5. كيف تضمنون دعم اللغة العربية والصلة الثقافية في تطوير منصتكم؟',
                        answer: 'لدينا متحدثون أصليون باللغة العربية في فريقنا يفهمون الفروق الدقيقة في اللغة والجوانب الثقافية. نضمن الترجمة العربية المناسبة ودعم الكتابة من اليمين إلى اليسار (RTL) وعناصر التصميم التي تتناسب مع المستخدمين العرب لتوفير تجربة أصيلة وسهلة الاستخدام.'
                    },
                    {
                        question: '6. هل تقدمون الدعم والصيانة المستمرة للمنصات التي تطورونها؟',
                        answer: 'نعم، نقدم خدمات دعم وصيانة شاملة لضمان بقاء منصتك محدثة وآمنة ومحسّنة. نوفر تحديثات منتظمة وإصلاحات للأخطاء وتحسينات في الأداء ومساعدة تقنية لتلبية احتياجاتك المتطورة.'
                    },
                    {
                        question: '7. كيف يمكننا البدء بخدمات تطوير الويب الخاصة بكم لمنصتنا العربية الكبيرة؟',
                        answer: 'ببساطة تواصل معنا من خلال موقعنا الإلكتروني أو معلومات الاتصال. سنحدد موعداً للاستشارة لمناقشة متطلباتك ونطاق المشروع والجداول الزمنية، ونقدم لك حلاً مخصصاً يتماشى مع أهدافك وغاياتك.'
                    }
                ],
                cta: {
                    title: 'لنبدأ مشروعك',
                    subtitle: 'لا تتردد',
                    buttonText: 'لننطلق'
                }
            },
            support: {
                title: 'دعم مخصص',
                description: 'هل تحتاج إلى دعم؟ أرسل تذكرة. سنكون سعداء بمساعدتك.',
                contactButton: 'اتصل بنا',
                supportTime: 'وقت الدعم:',
                supportDays: 'الأحد – الخميس',
                responseTime: 'وقت الاستجابة:',
                responseHours: 'بحد أقصى 24 ساعة'
            },
            footer: {
                agency: 'وكالة mass.Dev.',
                title: 'لنعمل معاً',
                contactButton: 'اتصل بنا'
            }
        },
        services: {
            subtitle: 'ما نقدمه',
            title: 'خدماتنا',
            description: 'حلول شاملة مصممة خصيصاً لاحتياجات عملك، من الاستراتيجية إلى التنفيذ.',
            items: [
                {
                    title: 'استراتيجية الأعمال',
                    description: 'استراتيجيات أعمال مخصصة للنمو والنجاح. رؤى مدفوعة بالبيانات، استشاريون خبراء، واتخاذ قرارات مستنيرة لنتائج مستدامة.'
                },
                {
                    title: 'تطوير المواقع الإلكترونية',
                    description: 'حلول تطوير ويب مخصصة لتواجدك الرقمي. برمجة احترافية، تصميم متجاوب، وتجارب مستخدم سلسة لتعزيز نجاحك الرقمي.'
                },
                {
                    title: 'التسويق والتقارير',
                    description: 'حلول تسويق وتقارير شاملة لتعزيز ظهور عملك. رؤى وتحليلات مدفوعة بالبيانات لاتخاذ قرارات مستنيرة ونتائج قابلة للقياس.'
                },
                {
                    title: 'تطوير تطبيقات الجوال',
                    description: 'تطوير تطبيقات جوال مبتكرة مصممة خصيصاً لاحتياجات عملك. واجهات مستخدم جذابة، وظائف سلسة، وأداء مثالي لأقصى تأثير.'
                },
                {
                    title: 'تصميم المواقع المالية',
                    description: 'خدمات تصميم مواقع مالية حديثة تعرض احترافيتك. واجهات نظيفة، تنقل بديهي، وميزات آمنة لبناء الثقة مع العملاء.'
                },
                {
                    title: 'تصميم تجربة المستخدم بالعربية',
                    description: 'خدمات تصميم تجربة مستخدم عربية احترافية لتجربة استثنائية. واجهات بديهية، تصاميم حساسة ثقافياً، وتفاعلات سلسة مصممة للمستخدمين الناطقين بالعربية.'
                }
            ]
        },
        portfolio: {
            subtitle: 'تأثيرنا',
            title: 'فعالياتنا المجانية',
            description: 'Mass.Dev تمكّن المجتمع بخبرة تجربة المستخدم، وتقدم فعاليات مجانية ومميزة لتحسين التجارب الرقمية للجميع.',
            readMore: 'اقرأ المزيد',
            viewProject: 'عرض المشروع',
            items: [
                {
                    id: 'jerusalem-ux-week',
                    category: 'تجربة المستخدم',
                    title: 'أسبوع تجربة المستخدم في القدس'
                },
                {
                    id: 'hebron-ux-freemium',
                    category: 'تجربة المستخدم',
                    title: 'تجربة المستخدم المجانية في الخليل'
                },
                {
                    id: 'web-dev-2023',
                    category: 'التطوير',
                    title: 'تطوير الويب في 2023'
                },
                {
                    id: 'empowering-fintech',
                    category: 'استراتيجية الأعمال',
                    title: 'تمكين التكنولوجيا المالية'
                },
                {
                    id: 'ai-dev-tickets',
                    category: 'تطوير الذكاء الاصطناعي',
                    title: 'الحصول على تذاكر للعرض الكبير'
                },
                {
                    id: 'dev-tickets',
                    category: 'التطوير',
                    title: 'الحصول على تذاكر للعرض الكبير'
                }
            ]
        },
        freemiums: {
            pageTitle: 'فعالياتنا',
            ourImpact: 'تأثيرنا',
            massDev: 'فعاليات Mass.Dev',
            ourFreemiums: 'فعالياتنا المجانية',
            description: 'Mass.Dev تمكّن المجتمع بخبرة تجربة المستخدم، وتقدم فعاليات مجانية ومميزة لتحسين التجارب الرقمية للجميع.',
            caseStudy: 'دراسة الحالة'
        },
        team: {
            title: 'فريق محترف',
            description: 'نقدم لكم فريقنا المحترف، خبراء في مجالاتهم، جاهزون لقيادة نجاحك بكفاءة لا مثيل لها.'
        },
        testimonial: {
            subtitle: 'آراء العملاء',
            title: 'ماذا يقول عملاؤنا',
            description: 'استمع إلى عملائنا الراضين حول تجربتهم في العمل مع MassDev.'
        },
        slogan: {
            subtitle: 'رؤيتنا',
            title: 'نبني الغد، اليوم',
            description: 'حيث يلتقي الابتكار بالتنفيذ، وتتحول الأفكار إلى تميّز رقمي.',
            mainSlogan: 'نبرمج بهدف. نبني بشغف. نتوسع بدقة.',
            subSlogan: 'نحن لا نكتب الأكواد فقط—بل نصمم أنظمة رقمية متكاملة تمكّن الأعمال، تُسعد المستخدمين، وتصمد أمام اختبار الزمن. من منصات التكنولوجيا المالية إلى الحلول المدعومة بالذكاء الاصطناعي، كل سطر نكتبه هو خطوة نحو نجاحك.',
            ctaButton: 'ابدأ رحلتك'
        },
        brand: {
            subtitle: 'شركاؤنا',
            title: 'موثوق به من قبل قادة الصناعة',
            description: 'نحن فخورون بالعمل مع العلامات التجارية والمؤسسات الرائدة في جميع أنحاء العالم.'
        },
        blog: {
            subtitle: 'مدونتنا',
            title: 'آخر الأخبار',
            description: 'ابقَ على اطلاع بأحدث الرؤى والاتجاهات والابتكارات في تطوير الويب والتكنولوجيا المالية.',
            readMore: 'اقرأ المزيد'
        },
        footer: {
            readyText: 'مستعد للقيام بذلك',
            heading: 'لنبدأ العمل',
            contactButton: 'اتصل بنا',
            quickLink: {
                title: 'روابط سريعة',
                explore: 'استكشف MassDev',
                projects: 'مشاريعنا',
                team: 'فريقنا',
                home: 'الرئيسية',
                letsTalk: 'لنتحدث'
            },
            sayHello: {
                title: 'قل مرحباً'
            },
            copyright: 'حقوق النشر © 2026 MassDev. جميع الحقوق محفوظة.'
        },
        contact: {
            pageTitle: 'اتصل بنا',
            breadcrumb: {
                title: 'تواصل معنا',
                description: 'نتطلع إلى الاستماع منك! اتصل بنا اليوم لمناقشة احتياجات تطوير الويب الخاصة بك وإنشاء تجارب رقمية استثنائية معاً.'
            },
            info: {
                phone: {
                    title: 'التواصل عبر رقم الهاتف'
                },
                email: {
                    title: 'عنوان البريد الإلكتروني'
                },
                location: {
                    title: 'الموقع',
                    address: 'شارع القلعة #3 القدس'
                }
            },
            form: {
                title: 'تواصل معنا.',
                description: 'نحن في انتظار رسالتك بفارغ الصبر! تواصل معنا اليوم لمناقشة متطلبات مشروعك ودعنا نحول رؤيتك إلى واقع.',
                fields: {
                    name: 'اسمك',
                    email: 'بريدك الإلكتروني',
                    phone: 'رقم الهاتف',
                    subject: 'الموضوع',
                    message: 'رسالتك'
                },
                submit: 'إرسال الآن',
                success: 'تم إرسال رسالتك بنجاح. سأتواصل معك قريباً.'
            }
        },
        servicePage: {
            pageTitle: 'الخدمات',
            breadcrumb: {
                title: 'الخدمات',
                home: 'الرئيسية'
            },
            development: {
                title: 'التطوير',
                description: 'Mass.Dev مصمم للجميع. لا يهم إذا كنت خبيراً في React أو مبتدئاً تماماً.',
                features: [
                    {
                        title: 'أطر عمل واجهة المستخدم الحديثة',
                        description: 'نحن متخصصون في React و Vue و Next.js، نقدم تطبيقات ويب استثنائية وتجارب مستخدم رائعة.'
                    },
                    {
                        title: 'تصميم متجاوب مثالي',
                        description: 'نحن متخصصون في تصميم الويب المتجاوب، نصنع مواقع ويب مذهلة بصرياً لجميع الأجهزة.'
                    },
                    {
                        title: 'قواعد بيانات NoSQL',
                        description: 'نحن متخصصون في التطوير باستخدام قواعد بيانات NoSQL، نوفر حلول بيانات قابلة للتوسع وفعالة.'
                    },
                    {
                        title: 'CSS من اليمين لليسار',
                        description: 'نحن متخصصون في تطوير أفضل CSS من اليمين لليسار لدعم اللغات السلس.'
                    },
                    {
                        title: 'تجربة مستخدم عربية',
                        description: 'نحن خبراء تجربة المستخدم العربية، نصنع تجارب مستخدم استثنائية مصممة خصيصاً للعالم العربي.'
                    },
                    {
                        title: 'تصميم حديث',
                        description: 'نحن متخصصون في تطوير تصاميم حديثة جذابة بصرياً ومبتكرة.'
                    },
                    {
                        title: 'نظام دعم على مدار الساعة',
                        description: 'نحن نقدم دعماً على مدار 24 ساعة لجميع العملاء.'
                    },
                    {
                        title: 'نظام إدارة المحتوى Shopify',
                        description: 'نحن متخصصون في إنشاء متاجر Shopify، نقدم تجارب تجارة إلكترونية سلسة للشركات.'
                    }
                ]
            }
        },
        aboutPage: {
            pageTitle: 'من نحن',
            breadcrumb: {
                title: 'من نحن',
                home: 'الرئيسية'
            },
            mainSection: {
                title: 'من نحن',
                description: 'هل تبحث عن حلول تطوير ويب متطورة مع تجربة مستخدم استثنائية؟ لا تبحث أكثر من Mass.Dev، وكالة رائدة في تطوير الويب الحديث وتجربة المستخدم في القدس. فريقنا من الخبراء الموهوبين والمبدعين هنا لتحقيق رؤيتك الرقمية.',
                whoWeAre: {
                    title: 'من نحن',
                    description1: 'نفخر بتقديم خدمات تطوير ويب من الدرجة الأولى تتجاوز الجماليات البحتة. نحن نفهم أهمية تجربة المستخدم وتأثيرها على نجاح تواجدك على الإنترنت. لهذا السبب يجمع فريقنا المتفاني بين البراعة التقنية والذوق الفني لإنشاء تجارب رقمية سلسة وجذابة.',
                    description2: 'حلول مخصصة لكل عمل: سواء كنت شركة ناشئة أو شركة صغيرة أو مؤسسة كبيرة، نقدم حلولاً قابلة للتوسع تتماشى مع أهدافك وميزانيتك المحددة. نهجنا المرن يضمن حصولك على استراتيجية تطوير ويب وتجربة مستخدم مخصصة تلبي احتياجات عملك.'
                }
            },
            culturalInsights: {
                title: 'رؤى ثقافية من القدس'
            },
            findWork: {
                title: 'ابدأ عملك الآن',
                description: 'رؤى ثقافية من القدس: تقع Mass.Dev في مدينة القدس النابضة بالحياة، نستمد الإلهام من التاريخ الغني والتنوع والإبداع الذي يحيط بنا. نضفي هذه الرؤى الثقافية على عملنا، لصياغة تجارب رقمية فريدة تتناغم مع السوق المستهدف',
                button: 'ابدأ الآن'
            },
            team: {
                title: 'فريق ماهر',
                description: 'خبرة في تطوير الويب الحديث: يواكب فريقنا من المطورين المتمرسين أحدث اتجاهات وتقنيات الصناعة. من تصميم الويب المتجاوب إلى تطبيقات الويب التفاعلية، لدينا المهارات لبناء حلول قوية مصممة خصيصاً لمتطلباتك الفريدة.'
            }
        },
        portfolioPage: {
            pageTitle: 'أعمالنا',
            breadcrumb: {
                title: 'أعمالنا',
                home: 'الرئيسية'
            },
            featured: {
                title: 'مميز',
                description: 'هناك العديد من الأشكال المتاحة لنصوص لوريم إيبسوم، ولكن الغالبية تعرضت للتغيير.'
            },
            allWorks: {
                title: 'جميع الأعمال',
                description: 'هناك العديد من الأشكال المتاحة لنصوص لوريم إيبسوم، ولكن الغالبية تعرضت للتغيير.',
                viewMore: 'عرض المزيد من المشاريع'
            },
            portfolioItems: [
                {
                    category: 'التطوير',
                    title: 'الحصول على تذاكر للعرض الكبير',
                    caseStudy: 'دراسة الحالة',
                    viewDetails: 'عرض التفاصيل'
                },
                {
                    category: 'التطوير',
                    title: 'الحصول على تذاكر للعرض الكبير',
                    caseStudy: 'دراسة الحالة',
                    viewDetails: 'عرض التفاصيل'
                },
                {
                    category: 'التطوير',
                    title: 'الحصول على تذاكر للعرض الكبير',
                    caseStudy: 'دراسة الحالة',
                    viewDetails: 'عرض التفاصيل'
                },
                {
                    category: 'التطوير',
                    title: 'الحصول على تذاكر للعرض الكبير',
                    caseStudy: 'دراسة الحالة',
                    viewDetails: 'عرض التفاصيل'
                },
                {
                    category: 'التطوير',
                    title: 'الحصول على تذاكر للعرض الكبير',
                    caseStudy: 'دراسة الحالة',
                    viewDetails: 'عرض التفاصيل'
                },
                {
                    category: 'التطوير',
                    title: 'الحصول على تذاكر للعرض الكبير',
                    caseStudy: 'دراسة الحالة',
                    viewDetails: 'عرض التفاصيل'
                }
            ]
        }
    }
};

export default translations;

